/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { WellContextService } from '@well/shared-providers';
import { take } from 'rxjs/operators';

@Directive({
  standalone: true,
  selector: '[wellHideOnNonRoAccounts]',
})
export class HideETransportEFacturaNonROAccountsDirective implements OnInit{
  private hasView: boolean | undefined = undefined;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private wellContextService: WellContextService
  ) {
  }

  ngOnInit(){
    this.wellContextService
      .getLoggedInContext()
      .pipe(take(1))
      .subscribe((loggedInContext: any) => {
        const companyCountry = loggedInContext.companyCountry;
        this.displayViewForRomanianCountry(companyCountry);
      });
  }

    displayViewForRomanianCountry(companyCountry: string) {
    if (companyCountry === 'RO') {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      }
    } else {
      if (this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    }
  }
}
